import styled from '@app/styled';
import { color, spacing } from '@app/theme';

export const Container = styled.div`
    margin-right: ${spacing(3)};
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
`;

export const Description = styled.span`
    display: block;
    color: ${color('custom.content.secondary')};
`;
